import { render, staticRenderFns } from "./ChallengeJoinButton.vue?vue&type=template&id=44677352&scoped=true&lang=pug&"
import script from "./ChallengeJoinButton.vue?vue&type=script&lang=js&"
export * from "./ChallengeJoinButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44677352",
  null
  
)

export default component.exports